import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { Layout, Menu } from 'antd'

import MarcaBlanco from '../../assets/imgs/marca-blanco.png'
import MarcaNegro from '../../assets/imgs/marca-negro.png'
import routes from './routes'
import Loader from '../../components/fileManager/loading'
import { useTheme } from '../../hooks/useTheme'
import CommonUnknownError from '../common/error/error'

const { Header, Content } = Layout

const PublicLayout = () => {
  const { data, isLoading, isError } = useTheme()

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      return <Route path={prop.path} component={prop.component} key={key} />
    })
  }

  if (isLoading) {
    return (<Loader />)
  }

  if (isError) {
    return (<CommonUnknownError />)
  }

  const { darkHeader } = data

  return (
    <Layout tyle={{ minHeight: '100vh' }}>
      <Header
        style={{
          padding: 0,
          position: 'fixed',
          zIndex: 10,
          width: '100%',
          height: 50
        }}
      >
        <div className='logo'>
          <img
            src={darkHeader === 'true' ? MarcaBlanco : MarcaNegro}
            width={150}
            alt='logo'
          />
        </div>
        <Menu
          theme={darkHeader === 'true' ? 'dark' : 'light'}
          mode='horizontal'
          style={{ display: 'block', height: 50 }}
        />
      </Header>
      <Layout
        className='site-layout'
        style={{
          marginLeft: 0,
          padding: '0px 16px 0',
          paddingTop: 50,
          minHeight: '100vh'
        }}
      >
        <Content style={{ padding: '0 50px' }}>
          <div style={{ paddingTop: 20, paddingLeft: 10, paddingRight: 10 }}>
            <Switch>{getRoutes(routes)}</Switch>
          </div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default PublicLayout
